import { Outlet, createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/reseller')({
  beforeLoad: requireRole('reseller'),
  component: Outlet,
})

